import { CourseStudentView } from '../list/types';

export enum StudentTypes {
    ADD_CONTENT_TO_COURSE_REQUEST = '@student/ADD_CONTENT_TO_COURSE_REQUEST',
    ADD_CONTENT_TO_COURSE_SUCCESS = '@student/ADD_CONTENT_TO_COURSE_SUCCESS',
    ADD_CONTENT_TO_COURSE_FAILURE = '@student/ADD_CONTENT_TO_COURSE_FAILURE',

    DELETE_CONTENT_FROM_COURSE_REQUEST = '@student/DELETE_CONTENT_FROM_COURSE_REQUEST',
    DELETE_CONTENT_FROM_COURSE_SUCCESS = '@student/DELETE_CONTENT_FROM_COURSE_SUCCESS',
    DELETE_CONTENT_FROM_COURSE_FAILURE = '@student/DELETE_CONTENT_FROM_COURSE_FAILURE',

    GET_ADDED_CONTENT_LIST_CLEAR = '@student/GET_ADDED_CONTENT_LIST_CLEAR',
    GET_ADDED_CONTENT_LIST_REQUEST = '@student/GET_ADDED_CONTENT_LIST_REQUEST',
    GET_ADDED_CONTENT_LIST_SUCCESS = '@student/GET_ADDED_CONTENT_LIST_SUCCESS',
    GET_ADDED_CONTENT_LIST_FAILURE = '@student/GET_ADDED_CONTENT_LIST_FAILURE',

    REORDER_CONTENT_LIST_REQUEST = '@student/REORDER_CONTENT_LIST_REQUEST',
    REORDER_CONTENT_LIST_SUCCESS = '@student/REORDER_CONTENT_LIST_SUCCESS',
    REORDER_CONTENT_LIST_FAILURE = '@student/REORDER_CONTENT_LIST_FAILURE',

    SET_ADDED_CONTENT_LIST = '@student/SET_ADDED_CONTENT_LIST',
}

export interface StudentListData {
    courseStudentView: CourseStudentView;
    loading: boolean;
    success: boolean;
    reorderSucess: boolean;
    hasError: boolean;
}

export interface StudentState {
    myListData: StudentListData;
}
